(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-section-2"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    initShoppableVideoSection();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var carousel = new bootstrap.Carousel(document.getElementById('shoppableVideosCarousel'), {
      interval: 5000,
      wrap: true,
    });
  });

  onclick = 'this.play();arguments[0].preventDefault();';

  $(document).ready(function () {
    var $window = $(window);
    var $scrollableRow = $('.scrollable-row');
    var $videos = $scrollableRow.find('video');

    function checkVideoVisibility() {
      var windowHeight = $window.height();
      var windowWidth = $window.width();
      var windowTop = $window.scrollTop();
      var windowLeft = $window.scrollLeft();
      var windowBottom = windowTop + windowHeight;
      var windowRight = windowLeft + windowWidth;
      var rowLeft = $scrollableRow.offset().left;
      var rowScrollLeft = $scrollableRow.scrollLeft();

      $videos.each(function () {
        var $video = $(this);
        var videoHeight = $video.outerHeight();
        var videoWidth = $video.outerWidth();
        var videoTop = $video.offset().top;
        var videoLeft = $video.offset().left;
        var videoBottom = videoTop + videoHeight;
        var videoRight = videoLeft + videoWidth;

        // Check if at least 50% of the video is visible both vertically and horizontally
        var verticallyVisible = videoTop < windowBottom - videoHeight / 2 && videoBottom > windowTop + videoHeight / 2;
        var horizontallyVisible = videoLeft < windowRight - videoWidth / 2 && videoRight > windowLeft + videoWidth / 2;

        if (verticallyVisible && horizontallyVisible) {
          if ($video[0].paused) {
            $video[0].play();
          }
        } else {
          if (!$video[0].paused) {
            $video[0].pause();
          }
        }
      });
    }

    // Check video visibility on scroll, on horizontal scroll of the row, and on window resize
    $window.on('scroll resize', checkVideoVisibility);
    $scrollableRow.on('scroll', checkVideoVisibility);

    // Initial check
    checkVideoVisibility();
  });

  } catch(e) { console.error(e); }
})();
})();
